import { propsUtil } from "@asphalt-react/helper"

/**
 * Gives supported size, defaults to 'm'
 * @param {string} size
 * @returns {string}
 */
export const resolveCodeSizeProp = (size) => {
  const supportedSizes = ["s", "m", "l"]
  return supportedSizes.includes(size) ? size : "m"
}

/**
 * Gives supported size, defaults to 'm'
 * @param {string} size
 * @returns {string}
 */
export const resolveBoldSizeProp = (size) => {
  const supportedSizes = ["xs", "s", "m", "l"]
  return supportedSizes.includes(size) ? size : "m"
}

/**
 * Gives supported size, defaults to 'm'
 * @param {string} size
 * @returns {string}
 */
export const resolveTextSizeProp = (size) => {
  const supportedSizes = ["xs", "s", "m", "l", "xl", "xxl"]
  return supportedSizes.includes(size) ? size : "m"
}

/**
 * Gives supported size, defaults to 'm'
 * @param {string} size
 * @returns {string}
 */
export const resolveDisplaySizeProp = (size) => {
  const supportedSizes = ["m", "l", "xl", "xxl"]
  return supportedSizes.includes(size) ? size : "m"
}

export const isBoldSize = (size) => {
  if (["xs", "s", "m", "l"].includes(size)) {
    return true
  }

  return false
}

export const resolveIntent = (intentProps) => {
  return propsUtil.resolvePropCollision(intentProps, "primary")
}
